import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      flex: 1,
      flexGrow: 1,
      padding: 0,
    },
    root: {
      flexGrow: 1,
    },
    wrapper: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      background: theme.palette.secondary.dark,
      // overflow: 'hidden',
      zIndex: 0,
      [theme.breakpoints.up('sm')]: {
        height: 'auto',
        background: theme.palette.secondary.light,
      },
    },
    img: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      height: '100%',
      width: '100%',
      objectFit: 'cover',
    },
    containerIntro: {
      paddingTop: 153,
      paddingBottom: 208,
      zIndex: 4,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.up('sm')]: {
        paddingTop: 126,
        paddingBottom: 120,
      },
    },
    textWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.up('sm')]: {
        maxWidth: 435,
      },
    },
    title: {
      marginBottom: 10,
      [theme.breakpoints.up('sm')]: {
        fontSize: 32,
      },
    },
    authorName: {
      fontSize: 16,
      fontWeight: 'bold',
      [theme.breakpoints.up('sm')]: {
        fontSize: 18,
      },
    },
    publishedAt: {
      fontSize: 14,
      [theme.breakpoints.up('sm')]: {
        fontSize: 16,
      },
    },
    gradient: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundImage: 'radial-gradient(at center, #6667ef 0%, #7cfef1 100%)',
      transition: 'background 0.3s, border-radius 0.3s, opacity 0.3s;',
      opacity: 0.3,
      [theme.breakpoints.up('sm')]: {
        backgroundImage: 'radial-gradient(at center left, #6667ef 0%, #7cfef1 100%)',
      },
    },
    topGradient: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: 300,
      background: 'linear-gradient(180deg, #1B1925 0%, rgba(45, 50, 56, 0.0) 100%) 0% 0% no-repeat',
      '-webkit-background-origin': 'padding-box',
      '-o-background-origin': 'padding-box',
      '-moz-background-origin': 'padding-box',
    },
    bottomGradient: {
      position: 'absolute',
      bottom: -1,
      left: 0,
      width: '100%',
      height: 373,
      background: 'linear-gradient(0deg, #1B1925 0%, rgba(45, 50, 56, 0.0) 100%) 0% 0% no-repeat',
      '-webkit-background-origin': 'padding-box',
      '-o-background-origin': 'padding-box',
      '-moz-background-origin': 'padding-box',
    },
    roundImageWrapper: {
      width: 60,
      height: 60,
      border: '2px solid colorsPalette.white',
      background: `${theme.palette.secondary.dark}`,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      margin: 'auto',
      overflow: 'hidden',
      [theme.breakpoints.up('sm')]: {
        width: 60,
        height: 60,
        marginBottom: 15,
      },
      '& img': {
        height: '100%',
        borderRadius: '40%',
        objectFit: 'cover',
      },
    },
    newsContent: {
      maxWidth: 292,
      margin: '0 auto',
      [theme.breakpoints.up('sm')]: {
        maxWidth: 950,
      },
    },
    descriptionBlock: {
      width: '100%',
      marginTop: -25,
      position: 'relative',
      zIndex: 4,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    introductionText: {
      width: '100%',
      margin: '0 auto',
      fontSize: 18,
      lineHeight: '1.5',
      textAlign: 'center',
      marginBottom: 48,
      color: colorsPalette.gray,
      [theme.breakpoints.up('sm')]: {
        fontSize: 26,
        marginBottom: 72,
        width: '80%',
      },
    },
    introductionImage: {
      width: '100vw',
      marginBottom: 48,
      borderRadius: 0,
      [theme.breakpoints.up('sm')]: {
        width: '100%',
        maxHeight: 740,
        maxWidth: '100%',
        marginLeft: 0,
        marginBottom: 72,
        borderRadius: 5,
      },
    },
    containerContent: {
      width: '100%',
      margin: '0 auto 20px',
      [theme.breakpoints.up('sm')]: {
        width: '80%',
        marginBottom: 22.5,
      },
      '& p': {
        fontSize: 18,
        lineHeight: '1.5',
        color: colorsPalette.gray,
        textAlign: 'left',
        marginTop: 0,
        marginBottom: 40,
      },
      '& li': {
        fontSize: 18,
        lineHeight: '1.5',
        color: colorsPalette.gray,
        textAlign: 'left',
        marginTop: 0,
        marginBottom: 40,
      },
      '& a': {
        color: '#7EFCF0',
      },
      '& a:hover': {
        textDecoration: 'underline',
        color: colorsPalette.violet,
      },
      '& img': {
        width: '100%',
        height: 'auto',
        marginBottom: 40,
        borderRadius: 5,
      },
    },
    socialContainer: {
      width: '100% - 16px',
      margin: '0 auto 72px',
      padding: 22,
      background: '#23202E 0% 0% no-repeat padding-box',
      boxShadow: `0px 3px 6px ${colorsPalette.black}`,
      borderRadius: 5,
      display: 'block',
      justifyContent: 'space-between',
      [theme.breakpoints.up('sm')]: {
        width: '80%',
        display: 'flex',
      },
    },
    shareText: {
      fontSize: 16,
      color: colorsPalette.gray,
      textAlign: 'center',
      [theme.breakpoints.up('sm')]: {
        textAlign: 'left',
      },
    },
    shareButtons: {
      textAlign: 'center',
      marginTop: 24,
      '& .react-share__ShareButton': {
        marginLeft: 16,
        outline: 'none',
        '&:first-of-type': {
          marginLeft: 0,
        },
        '& svg': {
          width: 24,
          height: 'auto',
          '& path': {
            fill: colorsPalette.gray,
          },
        },
        '&:hover svg path': {
          fill: colorsPalette.violet,
        },
      },
      [theme.breakpoints.up('sm')]: {
        textAlign: 'left',
        marginTop: 0,
      },
    },
  }),
);
export default useStyles;
